import { render, staticRenderFns } from "./UploadAMLDoc.vue?vue&type=template&id=0559e126"
import script from "./UploadAMLDoc.vue?vue&type=script&lang=js"
export * from "./UploadAMLDoc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports